import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { UserService } from '../../../layout/service/user.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-sheet-tutor',
    imports: [
        CommonModule,
        FormsModule
    ],
    template: `
<div class="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-100 py-10 px-2">
    <div class="max-w-6xl mx-auto">
        <h2 class="text-3xl md:text-4xl font-extrabold text-blue-900 mb-8 text-center drop-shadow">Daftar Kasus OSCE</h2>
        <div class="flex justify-center mb-8">
            <input
                type="text"
                [(ngModel)]="search"
                placeholder="Cari kasus OSCE..."
                class="w-full md:w-96 px-4 py-2 rounded-full border border-blue-200 shadow focus:outline-none focus:ring-2 focus:ring-blue-300 transition"
            />
        </div>
        <ng-container *ngIf="filteredForms.length > 0; else emptyCases">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                <div *ngFor="let form of filteredForms" class="relative bg-white rounded-3xl shadow-2xl border border-blue-100 group overflow-hidden transition hover:shadow-blue-200 hover:border-blue-400">
                    <!-- Decorative Gradient Accent -->
                    <div class="absolute -top-10 -left-10 w-40 h-40 bg-gradient-to-br from-blue-200 via-blue-100 to-transparent rounded-full opacity-40 pointer-events-none z-0"></div>
                    <div class="absolute -bottom-10 -right-10 w-32 h-32 bg-gradient-to-tr from-yellow-100 via-blue-50 to-transparent rounded-full opacity-30 pointer-events-none z-0"></div>
                    <div class="relative z-10 p-6 flex flex-col h-full">
                        <div class="mb-3 flex items-center gap-2">
                            <span class="inline-flex items-center gap-2 bg-blue-100/80 text-blue-700 text-xs md:text-sm px-3 py-1 rounded-full font-semibold shadow border border-blue-200">
                                <i class="pi pi-calendar"></i>
                                {{ form.created_at | date:'dd MMM yyyy, HH:mm' }}
                            </span>
                        </div>
                        <h3 class="text-lg font-bold text-blue-900 flex items-center gap-2 mb-2">
                            <i class="pi pi-briefcase text-blue-400"></i> {{ form.name }}
                        </h3>
                        <div class="text-gray-700 mb-4 line-clamp-3 min-h-[48px]">
                            {{ form.description || 'Tidak ada deskripsi.' }}
                        </div>
                        <div class="mt-auto flex justify-end">
                            <button type="button"
                                class="text-blue-700 hover:text-blue-900 font-semibold flex items-center gap-1 focus:outline-none transition"
                                (click)="$event.stopPropagation(); navigateToUserAnswer($event, form.id)">
                                Lihat Jawaban Siswa <i class="pi pi-chevron-right"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-template #emptyCases>
            <div class="flex flex-col items-center justify-center py-24">
                <i class="pi pi-inbox text-6xl text-blue-200 mb-4"></i>
                <div class="text-xl text-blue-900 font-semibold mb-2">Belum ada kasus OSCE</div>
                <div class="text-gray-500">Kasus OSCE akan tampil di sini jika sudah tersedia.</div>
            </div>
        </ng-template>
    </div>
</div>
    `
})
export class SheetTutor implements OnInit {
    forms: any[] = [];
    search: string = '';

    constructor(
        private userService: UserService,
        private router: Router
    ) {
        const userStr = localStorage.getItem('user');
        if (userStr) {
            try {
                const user = JSON.parse(userStr);

            } catch (e) {

            }
        }
    }

    ngOnInit() {
        this.userService.getSheetCases(null).then((res) => {
            this.forms = res.data;
        });


    }

    get filteredForms() {
        if (!this.search?.trim()) return this.forms;
        const s = this.search.trim().toLowerCase();
        return this.forms.filter(form =>
            (form.name && form.name.toLowerCase().includes(s)) ||
            (form.description && form.description.toLowerCase().includes(s))
        );
    }

    navigateToUserAnswer(event: Event, id: string) {
        event.stopPropagation();

        this.router.navigate(['app/osce/sheet/user/answer', id]);
    }
}
